import React from 'react';
import PropTypes from 'prop-types';

import Table from './Table';
import data from './SampleMovieData';

const columns = [
  {
    name: 'Title',
    selector: (row) => row.title,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Year',
    selector: (row) => row.year,
    sortable: true,
    numeric: true,
    filter: {
      type: 'MULTI_SELECT',
      options: [...new Set(data.map((movie) => movie.year))].sort(),
    },
  },
  {
    name: 'Director',
    selector: (row) => row.director,
    sortable: true,
    with_tooltip: true,
    filter: {
      type: 'SINGLE_SELECT',
      options: [...new Set(data.map((movie) => movie.director))].sort(),
    },
  },
  {
    name: 'Genres',
    selector: (row) => row.genres,
    format: (row) => row.genres.join(', '),
    with_tooltip: true,
  },
  {
    name: 'Actors',
    selector: (row) => row.actors,
    searchable: true,
    with_tooltip: true,
  },
  {
    name: 'Runtime',
    selector: (row) => row.runtime,
    sortable: true,
  },
  {
    name: 'Plot',
    selector: (row) => row.plot,
    with_tooltip: true,
    filter: {
      type: 'TEXT',
    },
  },
];

const rowActions = [
  {
    type: 'EXPAND',
  },
  {
    type: 'DIVIDER',
  },
  {
    title: 'Delete',
    type: 'CUSTOM',
    iconClass: 'trash-icon',
    href: (row) => `#delete-${row.id}`,
  },
  {
    title: 'Assign',
    type: 'CUSTOM',
    iconClass: 'assign-icon',
    href: (row) => `#assign-${row.id}`,
  },
];

export default function SampleTable({ displayData }) {
  return (
    <div className="sample-movies-table">
      <Table
        title="Sample Movies"
        columns={columns}
        data={displayData ? data : []}
        rowActions={rowActions}
      />
    </div>
  );
}

SampleTable.propTypes = {
  displayData: PropTypes.bool,
};

SampleTable.defaultProps = {
  displayData: true,
};
